import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "@helpers/translate";
import './index.sass'

const ActionButtons = ({ pairSlug }) => {
  const { __ } = useTranslation();
  const navigate = useNavigate();

  const handleTradeClick = () => {
    if (!pairSlug) return;
    navigate(`/?pair=${pairSlug}`);
  };

  return (
    <div className="markets-table-actions">
      <button
        className="markets-table-actions__button markets-table-actions__button--primary"
        type="button"
        onClick={handleTradeClick}
        disabled={!pairSlug}
      >
        {__("wallet.trade")}
      </button>
    </div>
  );
};

export default ActionButtons